const SystemManagementMutationTypes = {
  UPDATE_IS_LOADING: 'UPDATE_IS_LOADING',
  UPDATE_SELECTED_SYSTEMS: 'UPDATE_SELECTED_SYSTEMS',
};

export default SystemManagementMutationTypes;
